import React from 'react';
import logo from '../../../img/banobras.jpg';

export const Encabezado = (props) => {

    const { titulo } = props;
    return (
        <div>
            <div className="card">
                <div className="p-grid">
                    <div className="p-col-12 p-md-4"> <img src={logo} width="200" height="50" alt=""></img></div>
                    <div className="p-col-12 p-md-8"><h2>{titulo}</h2></div><div className="p-col-4"></div>
                </div>
            </div>
        </div>
    );
}